import { v4 as uuid } from 'uuid';

var uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function isUUID(string) {
  return Boolean(typeof string === 'string' && string.match(uuidRegex));
}

function addUUIDs(object) {
  if (object === null || typeof object !== 'object') return object;
  if (Array.isArray(object)) return object.map(addUUIDs);

  var returnObj = {};
  for (let [key, value] of Object.entries(object)) {
    if (key === 'id') {
      returnObj.uuid = object?.['uuid'] ?? uuid().toString();
    }
    returnObj[key] = addUUIDs(value);
  }
  return returnObj;
}

export { addUUIDs, isUUID };